import React  from "react";
import { protected_api_call, patient_form_url, patient_filter_url, patient_update_url, email_url } from "../api/api"
import { VscLoading } from "react-icons/vsc"
import { Calendar } from './InputElements/Calendar'
import { DropDown } from './InputElements/Dropdown'

class Info extends React.Component {

    state = {
        userinfo: "",
        loading: false,
        loadupdate: false,
        loadem: false,
        sched_state: "None",
        sched_date: new Date(),
        sched_state_e: "",
        sched_date_e: "",
        admin: false
    }

    update_patient_info = async () => {
        this.setState({loadupdate: true})
        if(this.state.sched_state === "None"){
            alert("Scheduling Status is a required field")
        }else{
            const currentUrl = window.location.href
            const id = parseInt(currentUrl.split("/").pop())
            let data = {
                "id": id,
                "ScheduledBoolean": this.state.sched_state,
                "scheduled_date": this.state.sched_date.toISOString().substr(0, 10)
            }
            let response = await protected_api_call(patient_update_url, data, "POST")
            if(response.status === 200){
                alert("Record Updated")
            }else{
                alert("Server Error")
            }
        }
        this.setState({loadupdate: false})
    }

    send_email = async () => {
        this.setState({loadem: true})
        if(this.state.userinfo.Email === ""){
            alert("Email is empty")
        }else{
            let data = {
                "fname": this.state.userinfo.FirstName,
                "lname": this.state.userinfo.LastName,
                "type": "onboard",
                "to": this.state.userinfo.Email,
            }
            let response = await protected_api_call(email_url, data, "POST")
            if(response.status === 200){
                alert("Email Sent!")
            }else{
                alert("Server Error")
            }
        }
        this.setState({loadem: false})
    }

    componentDidMount = async () => {
        let user_data = localStorage.getItem("user_data")
        user_data = JSON.parse(user_data)
        let admin_bool = user_data["details"]["HKAdmin"]
        admin_bool ? this.setState({admin: true}) : this.setState({admin: false})

        const currentUrl = window.location.href;
        const id = parseInt(currentUrl.split("/").pop());
        let response
        if(this.state.userinfo === ""){
            response = await protected_api_call(patient_filter_url, {"id": id}, "PUT") 
            if(response.status === 200){
                let text = JSON.parse(await response.text())
                this.setState({userinfo: text["data"]})
            }else{
                this.setState({userinfo: ""})
            }
        } 

    }

    delete_record = async () => {
        this.setState({loading: true})
        const currentUrl = window.location.href;
        const id = parseInt(currentUrl.split("/").pop());
        let response
        response = await protected_api_call(patient_form_url, {"id": id}, "DELETE") 
        if(response.status === 204){
            this.setState({userinfo: ""})
            this.setState({loading: false})
        }else if(response.status === 401){
            this.setState({loading: false})
            alert("Unauthorized")
        }else{
            this.setState({loading: false})
            alert("Conection Error")
        }
    }


    render() {
        console.log(this.state.userinfo.ScheduledBeforeTwoWeeks)
        return (
            <>
                <div className='flex justify-center items-center flex-col w-auto mt-20  rounded'>

                    {this.state.userinfo==="" ? (<>
                        RECORD NOT FOUND
                    </>):(
                        <div className='flex flex-col justify-center items-center h-1/2 w-full'>
                            <div className='flex justify-around bg-purple-600 text-white w-1/2 items-center m-1 p-2'>
                                <span><b>First Name:</b> {this.state.userinfo.FirstName}</span>
                                <span><b>Last Name:</b> {this.state.userinfo.LastName}</span>
                                <span><b>Date of Birth:</b> {this.state.userinfo.DateOfBirth}</span>
                            </div>

                            <div className='flex justify-around bg-purple-100 text-purple w-1/2 items-center m-1 p-2'>
                                <span className="w-2/5"><b>Address:</b> {this.state.userinfo.Address}</span>
                                <span><b>City:</b> {this.state.userinfo.City}</span>
                                <span><b>State:</b> {this.state.userinfo.State}</span>
                            </div>

                            <div className='flex justify-around bg-purple-100 text-purple w-1/2 items-center m-1 p-2'>
                                <span><b>Pincode:</b> {this.state.userinfo.Pincode}</span>
                                <span><b>Scheduled Before Two Weeks:</b> {this.state.userinfo.ScheduledBeforeTwoWeeks ? ("Yes"): ("No")}</span>
                            </div>

                            <div className='flex justify-around bg-purple-600 text-white w-1/2 items-center m-1 p-2'>
                                <span><b>Phone:</b> {this.state.userinfo.Phone}</span>
                                <span><b>Email:</b> {this.state.userinfo.Email}</span>
                            </div>

                            <div className='flex justify-around bg-purple-100 text-purple w-1/2 items-center m-1 p-2'>
                                <span><b>Hospital:</b> {this.state.userinfo.Hospital}</span>
                                <span><b>Diagnosos:</b> {this.state.userinfo.Diagonosis}</span>
                                <span><b>Criticality:</b> {this.state.userinfo.Criticality}</span>
                            </div>

                            <div className='flex justify-around bg-purple-600 text-white w-1/2 items-center m-1 p-2'>
                                <span><b>ESRD/CKD:</b> {this.state.userinfo.ESRD}</span>
                                <span><b>Insurance:</b> {this.state.userinfo.Insurance}</span>
                                <span><b>Referral:</b> {this.state.userinfo.Referral}</span>
                            </div>

                            <div className='flex justify-around bg-purple-100 text-purple w-1/2 items-center m-1 p-2'>
                                <span><b>Policy Number:</b> {this.state.userinfo.PolicyNumber}</span>
                                <span><b>Group Number:</b> {this.state.userinfo.GroupNumber}</span>
                            </div>

                            <div className='flex justify-around bg-purple-600 text-white w-1/2 items-center m-1 p-2'>
                                <span><b>Doctor:</b> {this.state.userinfo.SchedulingFrequency}</span>
                                <span><b>Scheduling Status:</b> {this.state.userinfo.ScheduledBoolean}</span>
                                {this.state.userinfo.ScheduledBoolean === "Scheduled" ? (<span><b>Scheduled Date:</b> {this.state.userinfo.scheduled_date}</span>):(<></>)}
                            </div>

                            <div className='flex justify-around bg-purple-100 text-purple w-1/2 items-center m-1 p-2'>
                                <span><b>Created By:</b> {this.state.userinfo.CreatedBy}</span>
                                <span><b>Created At:</b> {this.state.userinfo.CreatedAt.split("T")[0] + "  ->  " +this.state.userinfo.CreatedAt.split("T")[1].split(".")[0].split("Z")[0] }</span>
                            </div>

                            <div className='w-1/6'>
                                <button className='p-2 bg-orange-300 w-full text-white my-5 justify-center items-center flex rounded'
                                onClick={this.send_email}>
                                    {this.state.loadem ? (<VscLoading className='w-6 h-6 animate-spin'/>) : <b>Send form to patient</b>}
                                </button>
                            </div>

                            {this.state.admin==false ? (<></>):(
                                <div className='w-1/6'>
                                    <button className='p-2 bg-red-400 w-full text-white my-5 justify-center items-center flex rounded'
                                    onClick={this.delete_record}>
                                        {this.state.loading ? (<VscLoading className='w-6 h-6 animate-spin'/>) : <b>DELETE</b>}
                                    </button>
                                </div>
                            )}
                            
                        </div>
                    )}
                </div>
                
                {this.state.userinfo==="" ? (<></>):(
                    <>
                    <hr></hr>
                <div className='flex justify-center items-center flex-col w-auto rounded'>
                    <div class="ml-20 mt-10">

                        <DropDown errorMsg={this.state.sched_state_e} required={true} question="Scheduling Status" row={true}
                                options={["None", "Not Scheduled", "Scheduled", "Left Voicemail"]}
                                error={true} value={this.state.sched_state} onChange={(e) => {
                                    if(e.target.value==="None") this.setState({sched_state: e.target.value, sched_state_e: "This is a required field"})
                                    else this.setState({sched_state: e.target.value, sched_state_e: ""})
                                }}/>
                            
                        <Calendar errorMsg={this.state.sched_date_e} required={true} question="Scheduled Date" error={true} value={this.state.sched_date} onChange={(e) => {this.setState({sched_date: e})}}/>
                    </div>

                    <div className='justify-center flex'>
                        <button className='mx-5 px-10 py-2 bg-purple-700 w-20 text-white my-5 justify-center items-center flex rounded'
                        onClick={this.update_patient_info}>
                            {this.state.loadupdate ? <b>...</b>: <b>UPDATE</b>}
                            {/* {this.state.loadupdate ? (<VscLoading className='w-2 h-2 animate-spin'/>) : <b>UPDATE</b>} */}
                        </button>
                    </div>
                </div>
                    </>
                )}
                
            </>
        )
    }
}

export default Info;